<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate(materialtext) | capitalize }}</h1>
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <b-field>
            <b-input
              :placeholder="$translate('search').concat('...') | capitalize"
              type="search"
              icon="magnify"
              v-model="searchname"
              @input="searchData()"
            ></b-input>
          </b-field>
        </div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        checkable
        :checked-rows.sync="checkedRows"
        @check="checkMaterial($event)"
        detailed
        :default-sort="[sortField, sortOrder]"
        backend-sorting
        @sort="sortPressed"
      >
        <template slot-scope="props">
          <b-table-column field="CUI" :label="$translate('CUI') | capitalize" sortable>
            {{ props.row.CUI }}
          </b-table-column>
          <b-table-column field="commercial_name" :label="$translate('commercial_name') | capitalize" sortable>
            {{ $translateMaterial(props.row) }}
          </b-table-column>
          <b-table-column field="thickness" :label="$translate('thickness') | capitalize">
            {{ props.row.thickness }}
          </b-table-column>
          <b-table-column field="hardness" :label="$translate('hardness') | capitalize">
            {{ props.row.hardness }}
          </b-table-column>
          <b-table-column field="optional_tag" :label="$translate('optional_tag') | capitalize">
            <template v-for="item in props.row.optional_tag">
              {{ item.key }}
            </template></b-table-column
          >
        </template>
        <template slot="detail" slot-scope="props">
          <article v-for="variant in props.row.variants" v-bind:key="variant.id" class="media">
            <figure class="media-left">
              <p class="image">
                <img v-bind:src="variant.image" />
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ $translateMaterialVariant(variant) }}</strong
                  ><br />
                  {{ variant.id }} - {{ variant.CUIV }}
                  <br />
                  CUI:
                  <template v-if="variant.CUI_optionalbool">{{ variant.CUI_optional }}</template
                  ><template v-else>{{ props.row.CUI }}</template>
                </p>
              </div>
            </div>
          </article>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import materialTools from '../../../helpers/mixins/materialTools'

export default {
  name: 'AllestimentoTableMaterial',
  mixins: [materialTools],
  props: ['materialtext', 'allestimentoTable', 'module', 'CUIList'],
  data() {
    return {
      searchname: null,
      tableData: [],
      filteredData: [],
      checkedRows: [],
      loading: true,
      page: 1,
      total: 0,
      queryString: '',

      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,

      sortField: 'commercial_name',
      sortOrder: 'asc',
    }
  },
  watch: {
    allestimentoTable: function() {
      this.updateAfterload()
    },
    CUIList: function(CUIList) {
      const filteredMaterials = this.tableData.filter(m => CUIList.includes(m.CUI))
      this.checkedRows = []
      this.checkMaterial(filteredMaterials)
    },
  },
  mounted() {
    this.loadAsyncData()
  },
  methods: {
    sortPressed(field, order) {
      this.sortField = field
      this.sortOrder = order
      if (this.sortField == 'commercial_name') {
        this.filteredData.sort((a, b) => this.compareCommercialName(a, b))
      } else {
        this.filteredData.sort((a, b) => this.compareField(a, b))
      }
      if (this.sortOrder == 'desc') {
        this.filteredData.reverse()
      }
    },
    checkMaterial(rowchecks) {
      const materialiAllestimento = rowchecks.map(r => r.id)
      this.$emit('updateMaterials', materialiAllestimento)
    },
    updateAfterload() {
      this.checkedRows = []
      if (this.allestimentoTable.length !== 0) {
        for (let temptoadd of this.allestimentoTable) {
          this.checkedRows.push(this.tableData.find(temp => temp.id === temptoadd))
        }
      }
    },
    searchData() {
      this.filteredData = []
      this.tableData.forEach(material => {
        if (
          this.searchname == null ||
          this.$translateMaterial(material)
            .toLowerCase()
            .includes(this.searchname.toLowerCase()) ||
          material.CUI.toLowerCase().includes(this.searchname.toLowerCase()) ||
          material.optional_tag
            .map(e => e.key)
            .join(' ')
            .toLowerCase()
            .includes(this.searchname.toLowerCase())
        ) {
          this.filteredData.push(material)
        }
      })
    },
    loadAsyncData() {
      this.loading = true
      this.tableData = []
      this.getMaterialArray(this.materialtext)
        .then(arrayresponse => {
          this.tableData = arrayresponse
          this.filteredData = this.tableData
          this.loading = false
          this.sortPressed('commercial_name', 'asc')
        })
        .catch((this.tableData = []))
    },
  },
}
</script>

<style scoped>
.container >>> p.image img {
  height: auto;
  width: 100px;
}

.container >>> thead th:nth-child(9),
.container >>> thead th:nth-child(10),
.container >>> thead th:nth-child(11),
.container >>> thead th:nth-child(12),
.container >>> thead th:nth-child(13) {
  display: none;
}
</style>
